const BoxPrenotationLink = (props: any) => {

  let prenotation = props.prenotation || null

  let attendances = prenotation.attendances || []

  let attendanceFirst = attendances[0] || null
  return (
    <>
      {((attendanceFirst) ?

        <div className="boxPrenotationLink" onClick={props.handleClick}>
          <div className="row m-0">
            <div className="col-lg-8  p-0">
              <h4>{attendanceFirst.guestObject.name} {attendanceFirst.guestObject.surname}</h4>
              <p><b>#{prenotation._id}</b></p>

            </div>
            <div className="col-lg-4  pl-0 pr-0  text-right">
              <span className="material-symbols-outlined">
                arrow_forward_ios
              </span>
            </div>
          </div>
        </div>
        :
        <></>
      )}
    </>


  )
}

export default BoxPrenotationLink;
